import { Button, Checkbox, Empty, Flex, Form, Image, Input, message, Radio, Table, Tooltip, Typography } from "antd";
import { FC, useEffect, useState } from "react";
import NoData from "src/shared/images/noData.png";
import { SvgIcon } from "../../../../../shared/icons";
import { ConfirmButtons, CustomSelect, Modal } from "../../../../ui";
import "./index.less";
import { useDispatch, useSelector } from "react-redux";
// import { outreachCampaignSelector } from "src/store/outreach-campaigns";
// import { reactiveLinksSelector } from "src/store/reactive-links-settings";
import { teamSelector } from "src/store/user";

interface ConnectMembersToTeamModalProps {
  updateMembersList: (updatedMembersList: any) => void;
  onClose: () => void;
  teamConnectedToArr;
  setTeamConnectedToArr;
}

const weightedOptions = [
  {
    label: "High",
    value: 80,
  },
  {
    label: "Normal",
    value: 50,
  },
  {
    label: "Less",
    value: 20,
  },
];

export const ConnectMembersToLinkModal: FC<ConnectMembersToTeamModalProps> = ({ updateMembersList, onClose, teamConnectedToArr, setTeamConnectedToArr }) => {
  // const [fakeMembersList, setFakeMembersList] = useState([
  //   {
  //     id: "1",
  //     email: "meetzOutlooktest@outlook.com",
  //     getBookedWithLink: true,
  //     weighted: "High",
  //   },
  //   {
  //     id: "2",
  //     email: "tom@meetz.ai",
  //     getBookedWithLink: false,
  //     weighted: "Average",
  //   },
  // ]);

  // const handleCheckboxChange = (memberId: string, value: any) => {
  //   const updatedFakeMembersList = fakeMembersList.map((member) => (member.id === memberId ? { ...member, getBookedWithLink: value } : member));
  //   setFakeMembersList(updatedFakeMembersList);
  // };

  const handleSelectChange = (memberId: string, value: any) => {
    console.log(value, "updatedMembersListWeightbef");
    const updatedMembersListWeight = teamConnectedToArr.map((member) => (member.client_id === memberId ? { ...member, weighted: value } : member));
    console.log(updatedMembersListWeight, "updatedMembersListWeight");
    setTeamConnectedToArr(updatedMembersListWeight);
    message.success("Updated weight");
  };

  // const handleSubmitBtnClick = () => {
  //   updateMembersList(fakeMembersList);
  //   onClose();
  // };

  const columns = [
    {
      title: "Team Members Connected To This Round Robin",
      dataIndex: "client_id",
      key: "client_id",
      render: (data) => {
        const cli = pageInfo?.data?.team_members?.find((tm) => tm?.id === data);
        return <>{cli?.email}</>;
      },
    },
    // {
    //   title: "Get Booked With Link",
    //   dataIndex: "getBookedWithLink",
    //   key: "getBookedWithLink",
    //   render: (objPropValue: any, record: any) => (
    //     <Checkbox defaultChecked={record.getBookedWithLink} onChange={(e) => handleCheckboxChange(record.id, e.target.checked)} />
    //   ),
    // },
    {
      title: (
        <Flex gap={10} align={"center"}>
          <Typography.Paragraph className={"table-title"}>Weighted (Optional)</Typography.Paragraph>
          <Tooltip
            placement={"bottom"}
            title={
              <>
                {/* <b style={{ fontSize: "1.1em" }}>Weighted Team Member Assignment (Optional)</b> */}
                {/* <br /> */}
                Choose if certain team members should have a higher chance of being booked through this meeting link.
                <br />
                <br />
                <b> FAQ:</b> <br />
                <b> 1. Who can see these settings? </b>Only Super Admins and the Team Owner can view and manage weight settings for team members.
                <br />
                <br />
                <b> 2. What happens if I set everyone to "Higher"? </b>If all members are marked as “Higher,” the system treats them equally — as if everyone is
                set to “Average” To truly prioritize certain members, only assign “Higher” to those you want to receive more bookings. <br />
                <br />
                <b> 3. When should I use this feature?</b> The weighted option works best when you want to boost meeting distribution for specific team members.
                <br /> For example, if one of your top-performing Account Executives isn’t getting enough meetings, setting their weight to “Higher” will help
                send more opportunities their way.
              </>
            }
          >
            <SvgIcon type={"tooltip"} style={{ cursor: "pointer" }} />
          </Tooltip>
        </Flex>
      ),
      dataIndex: "weighted",
      key: "weighted",
      render: (objPropValue: string, record: any) => {
        console.log(record, "record2");
        return (
          <CustomSelect
            options={weightedOptions}
            defaultValue={objPropValue || 50}
            onChange={(value) => handleSelectChange(record.client_id, value)}
            isSearchSelect={false}
            style={{ width: 150 }}
          />
        );
      },
    },
  ];

  const [addTmMems, setAddTmMems] = useState(false);

  const onCancel = () => {
    setAddTmMems(false);
  }; // const { teamLinks } = useSelector(reactiveLinksSelector);
  const { clientWithTeam } = useSelector(teamSelector);
  const { pageInfo } = clientWithTeam;

  const [tmMems, setTmMems] = useState([] as { id: number | null; unixAdded; status; meetzStatus; email }[]);

  useEffect(() => {
    const data = [] as { id: number | null; unixAdded; status; meetzStatus; email }[];
    pageInfo?.data?.inactivated_emails?.forEach((inEmail) => {
      data.push({
        id: null,
        unixAdded: inEmail?.unixTime,
        email: inEmail?.email,
        status: inEmail?.type,
        meetzStatus: "inactive",
      });
    });
    pageInfo?.data?.team_members?.forEach((teamMem) => {
      console.log(teamMem, "teamMem");
      data.push({
        id: teamMem?.id,
        unixAdded: teamMem?.unixtime_added_to_team,
        email: teamMem?.email,
        status: teamMem?.teamStatus,
        meetzStatus: "active",
      });
    });
    setTmMems(data);
  }, [pageInfo]);

  // const navigate = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const closeModal = () => {
    onCancel();
    setTimeout(() => {
      setIsSubmitting(false);
    }, 1000);
  };

  const [memToShow, setMemToShow] = useState<number>(5);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [campToCopId, setCampToCopId] = useState<string | undefined>();

  const handleRadioBtnChange = (e: any) => {
    setCampToCopId(e.target.value);
    form.setFieldsValue({ camptocopy: e?.target?.value }); // Ensure form updates with selected campaign
  };

  const filteredPros = tmMems?.filter((item) => item?.email?.toLowerCase()?.includes(searchTerm?.toLowerCase()))?.slice(0, memToShow);

  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const onFinish = (vals) => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    // console.log(vals, "VALSVALS");
    console.log(vals?.contactsselected, "contactsselected");
    const teamMemInRR = vals?.contactsselected?.map((id) => ({
      client_id: id,
      weighted: teamConnectedToArr?.find((tm) => tm?.client_id === id)?.weighted || 50,
    }));
    setTeamConnectedToArr(teamMemInRR);
    // client_id;
    // weighted;
    // dispatch(addNewCampaignV2({ copyCampaign: { campName: vals?.name, campIdToCopy: vals?.camptocopy } }));

    message.success("Updated team members");
    closeModal();
  };

  const handleShowMore = () => {
    setMemToShow((prev) => prev + 1);
  };

  useEffect(() => {
    if (form) {
      const selectedIds = teamConnectedToArr?.map((member) => member?.client_id);
      form.setFieldsValue({ contactsselected: selectedIds });
    }
  }, [teamConnectedToArr, form]);

  return (
    <>
      <Modal
        open={addTmMems}
        title={"Add/Remove Team Members To Round Robin"}
        rootClassName={"connect-members-to-link-modal"}
        onCancel={() => setAddTmMems(false)}
        style={{ width: "200px" }}
      >
        <Form form={form} layout={"vertical"} className={"form"} onFinish={onFinish}>
          <Flex vertical gap={15}>
            {/* <Flex vertical gap={10}>
              <Typography.Paragraph>New campaign's name</Typography.Paragraph>
              <Form.Item
                name={"name"}
                // label={"New campaign's name"}
                rules={[{ required: true, message: "Please enter a campaign name" }]}
                style={{ width: "350px" }}
              >
                <Input placeholder={"Enter name"} />
              </Form.Item>
            </Flex> */}
            <Flex vertical gap={10}>
              <Typography.Paragraph>Search for team members</Typography.Paragraph>
              <Input.Search
                className={"search-input"}
                placeholder={"Team members email..."}
                allowClear
                prefix={<SvgIcon type={"search"} />}
                enterButton={false}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Form.Item name={"contactsselected"} style={{ width: "650px" }}>
                <Checkbox.Group
                  value={campToCopId ? [campToCopId] : []}
                  onChange={(checkedValues) => setCampToCopId(checkedValues.join(","))}
                  style={{ padding: "10px" }}
                >
                  <Flex gap={10} vertical>
                    {filteredPros?.length ? (
                      filteredPros.map((item, index) => (
                        // val can be unix just for no issue (BUT ID NEEDS TO BE THE VAL)
                        <Checkbox
                          key={`${index}-${item.unixAdded}`}
                          value={item?.meetzStatus === "inactive" || item?.status === "viewer" ? undefined : item.id}
                          disabled={item?.meetzStatus === "inactive" || item?.status === "viewer"}
                          className={item?.meetzStatus === "inactive" || item?.status === "viewer" ? "custom-disabled-checkbox" : ""}
                        >
                          {item.email}
                          {item?.meetzStatus === "inactive" ? "   (Inactive team member)" : item?.status === "viewer" ? "   (Viewer, can't be added)" : ""}
                        </Checkbox>
                      ))
                    ) : (
                      <div>No team member found</div>
                    )}
                    {tmMems?.length >= memToShow ? (
                      <Button className={"link"} style={{ marginRight: "auto" }} onClick={handleShowMore}>
                        Show more
                      </Button>
                    ) : (
                      ""
                    )}
                  </Flex>
                </Checkbox.Group>
              </Form.Item>
            </Flex>
            <br />
            <div style={{ position: "absolute", width: "85%", left: "auto", right: "auto", bottom: 20 }}>
              <ConfirmButtons
                handleSubmit={() => form.submit()} // Ensure form submission is triggered
                onCancel={closeModal}
                rightButtonTitle={"Update"}
                leftButtonTitle={"Back"}
                disabled={!tmMems?.length}
                disabledExplanation={`No team members found to add`}
              />
            </div>
          </Flex>
        </Form>
      </Modal>
      <Modal open={!addTmMems} title={"Connect Team Members To Link"} rootClassName={"connect-members-to-link-modal"} onCancel={onClose}>
        <Table
          dataSource={teamConnectedToArr || []}
          columns={columns}
          pagination={false}
          locale={{
            emptyText: (
              <Empty
                image={<Image preview={false} src={NoData} alt={"No data"} width={173} height={150} />}
                imageStyle={{
                  height: 180,
                  marginTop: "30px",
                }}
                description={<span style={{ marginTop: "10px" }}>Add team members to the round robin link below.</span>} // Add margin to separate text from the image
              />
            ),
          }}
        />
        <br />

        <div style={{ marginLeft: "auto", width: "fit-content" }}>
          <Button className="link" onClick={() => setAddTmMems(true)}>
            Add team members to the round robin
          </Button>
        </div>
        {/* <div style={{ width: "100%", marginRight: "auto", marginLeft: "auto" }}> */}
        {/* <div style={{ width: "50%", backgroundColor: "red", marginRight: "auto", marginLeft: "auto" }}> */}
        {/* <ConfirmButtons
          rightButtonTitle={"Save"}
          leftButtonTitle={"Back"}
          className={"confirm-buttons"}
          handleSubmit={handleSubmitBtnClick}
          onCancel={onClose}
        /> */}
        {/* </div> */}
        {/* </div> */}
      </Modal>
    </>
  );
};
